var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 141,
    viewBox: "0 0 200 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4854 106.289C60.2552 107.519 60.2552 109.514 61.4854 110.744C62.7155 111.974 64.71 111.974 65.9402 110.744L99.9999 76.6843L134.06 110.745C135.29 111.975 137.285 111.975 138.515 110.745C139.745 109.514 139.745 107.52 138.515 106.29L104.455 72.2295L141.438 35.2465C142.668 34.0163 142.668 32.0218 141.438 30.7917C140.208 29.5615 138.213 29.5615 136.983 30.7917L99.9999 67.7747L63.0174 30.7923C61.7873 29.5621 59.7928 29.5621 58.5626 30.7923C57.3325 32.0224 57.3325 34.0169 58.5626 35.247L95.5451 72.2295L61.4854 106.289Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseHover);
export default __webpack_public_path__ + "static/media/closeHover.7dd5e905ae1834454343a22d61af8118.svg";
export { ForwardRef as ReactComponent };